<template>
    <div class="app" v-if="loaded" :style="instanceStyle">
        <TopNavBar class="topnavbar" v-if="currentUser" />
        <LoginView v-if="currentUser == null && !meta.allowUnauthorized" />
        <SideBarPage v-if="currentUser" class="sidebar" />
        <router-view class="routerview" v-if="currentUser || meta.allowUnauthorized"></router-view>
    </div>
</template>

<script>
import LoginView from "@/views/users/Login.vue"
import TopNavBar from '@/components/Navbar.vue'
import SideBarPage from "./views/SideBar.vue";
import { swapTitle } from 'tabky-js';

export default {
    name: 'App',
    props: {
    },
    components: {
        LoginView,
        TopNavBar,
        SideBarPage,
    },
    data() {
        return {
            style: true,
            mobileMenu: false,
        }
    },
    methods: {
        async getConsumersAndWorkers() {
            if (this.instanceId == null) {
                return
            }
            if (this.currentUser == null) {
                return
            }

            document.title = this.$store.state.instance.name;
            swapTitle({
                title: document.title,
            });

            this.$store.dispatch("users/getAll");
            await this.$store.dispatch("users/getRole", { userId: this.currentUser.uid });
            this.$store.dispatch("projects/getAll");
            this.$store.dispatch("services/getAll");
            this.$store.dispatch("workers/getAll");
            this.$store.dispatch("consumers/getAll");
        }
    },
    computed: {
        currentUser() {
            return this.$store.state.users.currentUser
        },
        instance() {
            return this.$store.state.instance.data
        },
        instanceId() {
            return this.$store.state.instanceId
        },
        loaded() {
            return this.$store.state.instance.loaded
        },
        instanceStyle() {
            if (!this.style) {
                return null
            }
            return this.$store.state.instance.data.style
        },
        meta() {
            return this.$route.meta
        },
    },

    watch: {
        currentUser: {
            immediate: true,
            handler() {
                this.getConsumersAndWorkers()
            },
        },
        instance: {
            immediate: true,
            handler() {
                if (this.instance == null) {
                    return
                }
                swapTitle({
                    title: this.instance.name,
                });
            },
        },
        instanceId: {
            immediate: true,
            handler() {
                this.getConsumersAndWorkers()

                if (this.instanceId == null) {
                    return
                }

                if (this.instance.messages == null) {
                    return
                }

                const defaultMessages = this.$i18n.getLocaleMessage('en')
                this.$i18n.setLocaleMessage('en', null)
                for (let locale in this.instance.messages) {
                    this.$i18n.setLocaleMessage(locale, {
                        ...defaultMessages,
                        ...this.instance.messages[locale],
                    })
                }
                this.$i18n.locale = this.instance.locale
            },
        },
    },
    mounted() {
        this.$store.dispatch("instance/get")
    }
}
</script>

<style lang="scss">
@import './assets/utilities/_variables.scss';


* {
    box-sizing: border-box;
}

.firebase-emulator-warning {
    display: none;
}

body {
    font-family: var(--font-family-sans-serif);
    font-size: var(--font-size-base);
    line-height: var(--line-height-base);
    color: var(--text-color);
    background: var(--body-bg);
    width: 100%;
    margin: auto;
    position: relative;
}

input,
select,
textarea {
    font-family: var(--font-family-sans-serif);
}


.clients-sidebar {
    grid-area: clients;
}

.sidebar {
    grid-area: sidebar;

    &.is-collapsed+.routerview+.topnavbar {
        padding-left: var(--sidebar-collapsed-width);
    }
}

.topnavbar {
    grid-area: topnavbar;
    transition: padding .2s ease-in-out;
}

.routerview {
    grid-area: routerview;
    display: flex;
    flex-direction: column;
    max-height: 100vh;
    width: 100%;
    transition: padding .2s ease-in-out;
    overflow: auto;
}

#app {
    width: var(--vw);
    height: var(--vh);

    .app {
        background-color: var(--body-bg);
        color: var(--text-color);
        height: var(--vh);
        display: grid;
        grid-template-rows: auto 1fr;
        grid-template-columns: 1fr;
        grid-template-areas:
            'topnavbar'
            'routerview';

        @media screen and (min-width: $desktop-min-width) {
            grid-template-columns: min-content 1fr;
            grid-template-areas:
                'sidebar topnavbar'
                'sidebar routerview';
        }
    }
}

h4 {
    font-family: "DINPro", Helvetica, Roboto, Arial, sans-serif;
    font-weight: normal;
    font-style: normal;
    color: rgba(var(--black), 1);
    text-rendering: optimizeLegibility;
    margin-top: 0.2rem;
    margin-bottom: 0.5rem;
}

h3 {
    font-family: "DINPro", Helvetica, Roboto, Arial, sans-serif;
    font-style: normal;
    text-rendering: optimizeLegibility;
}

a {
    text-decoration: none;
    color: inherit;
}
</style>
